// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {BendPin} from './bend-pin.js'

export class Bend {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Bend {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  pin(): BendPin {
    return this.bb!.readInt8(this.bb_pos)
  }

  offset(): number {
    return this.bb!.readFloat32(this.bb_pos + 4)
  }

  static sizeOf(): number {
    return 8
  }

  static createBend(builder: flatbuffers.Builder, pin: BendPin, offset: number): flatbuffers.Offset {
    builder.prep(4, 8)
    builder.writeFloat32(offset)
    builder.pad(3)
    builder.writeInt8(pin)
    return builder.offset()
  }
}
